import { useEffect } from 'react';

// How far the button follows the pointer, as a share of the pointer's offset
// from the button's centre, and how far it can ever travel.
const PULL_X = 0.25;
const PULL_Y = 0.35;
const MAX = 10;

/**
 * Elements marked `data-magnetic` lean towards the pointer while it is over
 * them and spring back on leave. Transform only, eased by CSS. Off for touch
 * pointers and `prefers-reduced-motion`.
 */
export default function MagneticButtons() {
  useEffect(() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const clamp = (v) => Math.max(-MAX, Math.min(MAX, v));
    const onMove = (e) => {
      const el = e.target.closest && e.target.closest('[data-magnetic]');
      if (!el) return;
      const r = el.getBoundingClientRect();
      const dx = e.clientX - (r.left + r.width / 2);
      const dy = e.clientY - (r.top + r.height / 2);
      el.style.transition = 'transform 0.15s ease-out';
      el.style.transform = `translate3d(${clamp(dx * PULL_X)}px, ${clamp(dy * PULL_Y)}px, 0)`;
    };
    const onOut = (e) => {
      const el = e.target.closest && e.target.closest('[data-magnetic]');
      if (!el || el.contains(e.relatedTarget)) return;
      el.style.transition = 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
      el.style.transform = '';
    };
    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerout', onOut);
    return () => {
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerout', onOut);
    };
  }, []);
  return null;
}
